class CartNotification extends HTMLElement {
  constructor() {
    super();
    this.notification = this.querySelector('#cart-notification');
    if (!this.notification) return;
    this.header = document.querySelector('sticky-header');

    this.notification.addEventListener('cancel', (event) => {
      event.preventDefault();
      this.close();
    });
    this.notification.addEventListener('close', () => this.finishClose());
    this.notification.addEventListener('click', (event) => this.handleBackdropClick(event));
    this.querySelectorAll('[data-cart-notification-close]').forEach((button) => {
      button.addEventListener('click', () => this.close());
    });
  }

  open() {
    if (!this.notification) return;
    if (!this.notification.open) {
      if (!this.activeElement || !this.activeElement.isConnected) {
        this.activeElement = document.activeElement;
      }
      removeTrapFocus();
      this.notification.showModal();
    }
    document.body.classList.add('cm-cart-notification-open');
    this.notification.classList.add('active');
    this.notification.focus({ preventScroll: true });
  }

  close() {
    if (!this.notification || !this.notification.open) return;
    this.notification.classList.remove('active');
    this.notification.close();
  }

  finishClose() {
    if (this.notification.open) return;
    document.body.classList.remove('cm-cart-notification-open');
    this.notification.classList.remove('active');
    if (this.activeElement && this.activeElement.isConnected) {
      this.activeElement.focus({ preventScroll: true });
    }
    this.activeElement = null;
  }

  disconnectedCallback() {
    if (this.notification && this.notification.open) {
      this.notification.close();
      this.finishClose();
    }
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key || (parsedState.items && parsedState.items[0] && parsedState.items[0].key);
    const summary = this.querySelector('[data-cart-notification-summary]');
    if (summary) summary.hidden = true;

    this.getSectionsToRender().forEach((section) => {
      const sectionElement = document.getElementById(section.id);
      if (!sectionElement) return;
      const html = this.getSectionInnerHTML(parsedState.sections && parsedState.sections[section.id], section.selector);
      if (html === null) return;
      sectionElement.innerHTML = html;
      if (section.id === 'cart-notification-button' && summary) {
        const count = sectionElement.querySelector('[data-cart-summary-label]');
        const label = summary.querySelector('[data-cart-notification-summary-text]');
        if (count && label) {
          label.textContent = count.getAttribute('data-cart-summary-label');
          summary.hidden = false;
        }
      }
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      { id: 'cart-notification-button' },
      { id: 'cart-icon-bubble' },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    if (!html) return null;
    const node = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return node ? node.innerHTML : null;
  }

  handleBackdropClick(event) {
    if (event.target !== this.notification) return;
    const rect = this.notification.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right ||
        event.clientY < rect.top || event.clientY > rect.bottom) {
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
